var _TAB_KEY_TO_DATA_KEY;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { isError, get, defaultTo, attempt, reduce } from 'lodash';
import dayjs from 'dayjs';
import { currencyUtil } from '@yy/sl-tools';
import i18n from './i18n';
import { ECardChannel } from '../types/card';
var isObject = function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
};
var isLaxNull = function isLaxNull(value) {
  return value === '' || value === undefined || value === null;
};
function formatApiIntl(data, options) {
  var _ref = options || {},
    lang = _ref.lang;
  var currentLang = lang || i18n.language;
  if (isObject(data)) {
    return data[currentLang] || data['en'] || '';
  }
  if (typeof data === 'string') {
    try {
      var dataJson = JSON.parse(data);
      return dataJson[currentLang] || dataJson['en'] || '';
    } catch (error) {
      return "".concat(data || '');
    }
  }
  return "".concat(data || '');
}
function getPriceByCurrencyCode(price) {
  var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  if (typeof price === 'string') {
    var priceJson = safeParse(price, _defineProperty({}, currencyCode, Number(price)));
    return priceJson[currencyCode] || 0;
  }
  return price;
}
function formatPriceJson(price) {
  var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  var lang = arguments.length > 2 ? arguments[2] : undefined;
  var multiple = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  if (!price && price !== 0) return '';
  var curPrice = getPriceByCurrencyCode(price, currencyCode);
  var currentLang = lang || i18n.language;
  return currencyUtil.format(curPrice * multiple, {
    lang: currentLang,
    code: currencyCode,
    mappingSymbolInConst: true
  });
}
export function safeGet() {
  return defaultTo(get.apply(void 0, arguments), arguments.length <= 2 ? undefined : arguments[2]);
}

// 安全stringify，避免因为未知的值不合法导致报错
export function safeStringify(value, defaults) {
  var handled = attempt(JSON.stringify, value);
  return isError(handled) ? defaults : handled;
}

// 安全parse，避免因为未知的值不合法导致报错
export function safeParse(value, defaults) {
  var handled = attempt(JSON.parse, value);
  return isError(handled) ? defaults : handled;
}
export function safeFormat(value, options) {
  var _Object$assign = Object.assign({
      pattern: 'YYYY-MM-DD HH:mm:ss',
      placeholder: '--'
    }, options),
    pattern = _Object$assign.pattern,
    placeholder = _Object$assign.placeholder;
  if (isLaxNull(value)) {
    return placeholder;
  }
  return !dayjs(value).isValid() ? placeholder : dayjs(value).format(pattern);
}

// 可以代替 try/catch 语句使用
export function catchWith(promise) {
  return promise.then(function (data) {
    return {
      data: data,
      error: null
    };
  }).catch(function (error) {
    return {
      data: null,
      error: error
    };
  });
}

/**
 * 从备选路径数组中获取目标值
 * @param target 要取值的对象，一般是 Object 或者 Array
 * @param alters 取值路径数组，数组元素是单个元素的取值路径
 * @param predicate 在遍历路径数组过程中，判断是否要取值的方法
 * @returns any
 * @example alterGet({ name: '小明' }, ['路径一', '路径二', 'name']) => '小明'
 * @example alterGet({ name: '小明' }, ['路径一', '路径二', 'name2']) => null
 */
export function alterGet(target, alters, predicate) {
  var predicateFn = typeof predicate === 'function' ? predicate : function (value) {
    return !isLaxNull(value);
  };
  for (var index = 0, length = alters === null || alters === void 0 ? void 0 : alters.length; index < length; index += 1) {
    var getted = get(target, alters[index]);
    if (predicateFn(getted)) {
      return getted;
    }
  }
  return null;
}
export function delay() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(true);
    }, timeout);
  });
}

/**
 * 生成一个多个key映射同一个value的object
 * @param map { 'key1|key2|key3': 'common-value' }
 * @param separator key的分隔符
 * @returns object
 * @example { 'key1|key2|key3': 'common-value' } => { key1: 'common-value', key2: 'common-value', key3: 'common-value' }
 */
export function generateQueryMap(map) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '|';
  var buffer = {};
  return reduce(map, function (acc, value, keysString) {
    var keys = keysString.split(separator);
    keys.forEach(function (key) {
      acc[key] = value;
    });
    return acc;
  }, buffer);
}
function getMessage() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function (sid, data) {
    var formatPrefix = prefix ? "".concat(prefix.replace(/\.$/, ''), ".") : '';
    var id = "".concat(formatPrefix).concat(sid);
    return i18n.t(id, data);
  };
}

/**
 *
 * @param prefix i18n key 前缀
 * @param key i18n key 值
 * @param data 插值
 * @returns i18n 语料 | null
 */
function getI18nErrMsg(prefix, key, data) {
  try {
    var trans = getMessage(prefix);
    var msg = trans(key, data);

    // 如果缺失翻译或者语料不存在(语料不存在时msg会返回*key*的格式)
    if (!msg || /^\*.*\*$/.test(msg)) {
      return null;
    }
    return msg;
  } catch (err) {}
  return null;
}

// tab key映射的数据key
export var TAB_KEY_TO_DATA_KEY = (_TAB_KEY_TO_DATA_KEY = {}, _defineProperty(_TAB_KEY_TO_DATA_KEY, ECardChannel.stripe, 'creditList'), _defineProperty(_TAB_KEY_TO_DATA_KEY, ECardChannel.checkout, 'checkoutCreditList'), _TAB_KEY_TO_DATA_KEY);
export { isObject, isLaxNull, formatPriceJson, formatApiIntl, getMessage, getI18nErrMsg };